/* shop.debands.xyz — product page: gallery thumbnails and variant pills.
   Add to bag is Dawn's <product-form> (product-form.js) and quantity is
   Dawn's <quantity-input> (global.js); this file only swaps the image and
   keeps the variant id, price and button in step with the selected options. */
(function () {
  function init(scope) {
    var page = scope.querySelector('[data-product-page]');
    if (!page || page.dataset.ready) return;
    page.dataset.ready = 'true';

    var main = page.querySelector('.pdp__plate img');
    var thumbs = Array.prototype.slice.call(page.querySelectorAll('.pdp__thumb'));

    function showThumb(thumb) {
      if (!main || !thumb) return;
      main.srcset = thumb.dataset.srcset;
      main.src = thumb.dataset.src;
      main.alt = thumb.dataset.alt;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showThumb(thumb); });
    });

    var data = page.querySelector('[data-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = page.querySelector('input[name="id"]');
    var form = page.querySelector('product-form');
    var button = page.querySelector('.pdp__add');
    var label = button.querySelector('span');
    var now = page.querySelector('[data-price-now]');
    var was = page.querySelector('[data-price-was]');
    var wasValue = page.querySelector('[data-price-was-value]');
    var soldOut = page.querySelector('[data-sold-out]');
    var fieldsets = Array.prototype.slice.call(page.querySelectorAll('.pdp__option'));

    function update() {
      var selected = fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      var variant = variants.filter(function (v) {
        return v.options.every(function (value, i) { return value === selected[i]; });
      })[0];

      if (!variant) {
        button.disabled = true;
        label.textContent = page.dataset.unavailableLabel;
        return;
      }

      idInput.value = variant.id;
      now.textContent = variant.price;
      was.hidden = !(variant.available && variant.compare);
      if (variant.compare) wasValue.textContent = variant.compare;
      soldOut.hidden = variant.available;
      button.disabled = !variant.available;
      if (form) form.classList.toggle('is-sold-out', !variant.available);
      label.textContent = variant.available ? page.dataset.addLabel : page.dataset.soldOutLabel;

      if (variant.media) {
        showThumb(thumbs.filter(function (t) { return t.dataset.mediaId === String(variant.media); })[0]);
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    page.querySelectorAll('[data-option-index]').forEach(function (input) {
      input.addEventListener('change', update);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
